export const stemiProcedureCreateTranslations = {
    en: {
        fetchOpdFailed: "Failed to fetch OPD numbers!",
        selectCampError: "Please select a health camp!",
        submitSuccess: "Mukhyamantri Hriday Sanjivani Consultation added successfully!",
        submitFailed: "Failed to add procedure!",
        submitting: "Submitting...",
        submit: "Submit",

        patientInformation: "Patient Information",
        tokenNo: "Token No",
        tokenPlaceholder: "Search Token No eg. 00005",
        beneficiaryName: "Beneficiary Name",
        date: "Date",

        vitals: "Vitals",
        bloodPressure: "Blood Pressure (mmHg)",
        bpPlaceholder: "e.g., 120/80",
        heartRate: "Heart Rate (bpm)",
        respiratoryRate: "Respiratory Rate (breaths/min)",
        spo2: "SpO2 (%)",

        uploadFiles: "Upload Files (if any)",

        symptomsAndFindings: "Symptoms and Findings",
        presentingSymptoms: "Presenting Symptoms",
        ecgFindings: "ECG Findings",

        remarks: "Remarks",
        remark: "Remark"
    },
    mr: {
        fetchOpdFailed: "ओपीडी क्रमांक आणण्यात अयशस्वी!",
        selectCampError: "कृपया आरोग्य शिबिर निवडा!",
        submitSuccess: "मुख्यमंत्री हृदय संजीवनी सल्ला यशस्वीरित्या जोडला!",
        submitFailed: "प्रक्रिया जोडण्यात अयशस्वी!",
        submitting: "सबमिट करत आहे...",
        submit: "सबमिट करा",

        patientInformation: "रुग्ण माहिती",
        tokenNo: "टोकन क्रमांक",
        tokenPlaceholder: "टोकन क्रमांक शोधा उदा. 00005",
        beneficiaryName: "लाभार्थीचे नाव",
        date: "तारीख",

        vitals: "जीवनचिन्हे",
        bloodPressure: "रक्तदाब (mmHg)",
        bpPlaceholder: "उदा., 120/80",
        heartRate: "हृदय गती (bpm)",
        respiratoryRate: "श्वसन दर (श्वास/मिनिट)",
        spo2: "SpO2 (%)",

        uploadFiles: "फाइल अपलोड करा (असल्यास)",

        symptomsAndFindings: "लक्षणे आणि निष्कर्ष",
        presentingSymptoms: "सादर लक्षणे",
        ecgFindings: "ECG निष्कर्ष",

        remarks: "शेरा",
        remark: "टिप्पणी"
    }
};
